(function($){
    // $(document).on('click', 'a', function(e) {
    //     var href = $(this).attr('href');
    //
    //     if (href && href.startsWith('#') && href.length > 1) {
    //         var targetId = href.substring(1); // usuń '#'
    //         var $target = $('#' + targetId);
    //
    //         if ($target.length) {
    //             e.preventDefault();
    //
    //             $('html, body').animate({
    //                 scrollTop: $target.offset().top
    //             }, 500);
    //         }
    //     }
    // });
})(jQuery)